/**
 * Island Rituals – Track Order
 *
 * Two tabs:
 *  1. Order Number + Email → Vercel API → Shopify Admin API
 *  2. AWB Number → Binderbyte API (live) or JNE website (fallback)
 */
document.addEventListener("DOMContentLoaded", function () {
  var root = document.querySelector("[data-ir-to]");
  if (!root) return;

  /* ---- Shared ---- */
  var tabs        = root.querySelectorAll("[data-tab]");
  var panels      = root.querySelectorAll("[data-panel]");
  var loadingEl   = root.querySelector("[data-loading]");
  var resultEl    = root.querySelector("[data-result]");
  var labelEl     = root.querySelector("[data-result-label]");
  var badgeEl     = root.querySelector("[data-result-badge]");
  var timelineEl  = root.querySelector("[data-result-timeline]");
  var externalEl  = root.querySelector("[data-result-external]");
  var apiKey      = (root.getAttribute("data-api-key") || "").trim();
  var workerUrl   = (root.getAttribute("data-worker-url") || "").trim();

  /* ---- Order form ---- */
  var orderForm   = root.querySelector("[data-form-order]");
  var orderInput  = root.querySelector("[data-input-order]");
  var emailInput  = root.querySelector("[data-input-email]");
  var errorOrder  = root.querySelector("[data-error-order]");

  /* ---- AWB form ---- */
  var awbForm     = root.querySelector("[data-form-awb]");
  var awbInput    = root.querySelector("[data-input-awb]");
  var errorAwb    = root.querySelector("[data-error-awb]");

  /* ============================================================
     TAB SWITCHING
     ============================================================ */
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var target = tab.getAttribute("data-tab");
      tabs.forEach(function (t) {
        var active = t.getAttribute("data-tab") === target;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-panel") === target);
      });
      resultEl.classList.remove("is-active");
      if (errorOrder) errorOrder.classList.remove("is-active");
      if (errorAwb) errorAwb.classList.remove("is-active");
    });
  });

  /* ---- Track Again button ---- */
  var trackAgainBtn = root.querySelector("[data-track-again]");
  if (trackAgainBtn) {
    trackAgainBtn.addEventListener("click", function () {
      resultEl.classList.remove("is-active");
      root.querySelector(".ir-to__card").scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  /* ============================================================
     ORDER NUMBER + EMAIL  →  Vercel API
     ============================================================ */
  if (orderForm) {
    orderForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var order = (orderInput.value || "").trim().replace(/^#/, "");
      var email = (emailInput.value || "").trim();

      if (!order || !email) {
        errorOrder.classList.add("is-active");
        if (!order) orderInput.focus(); else emailInput.focus();
        return;
      }

      errorOrder.classList.remove("is-active");

      if (!workerUrl) {
        errorOrder.textContent = "Order lookup is not configured yet. Please use AWB Number instead.";
        errorOrder.classList.add("is-active");
        return;
      }

      resultEl.classList.remove("is-active");
      loadingEl.classList.add("is-active");

      var btn = orderForm.querySelector(".ir-to__btn");
      if (btn) btn.disabled = true;

      fetch(workerUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orderName: order,
          email: email
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          loadingEl.classList.remove("is-active");
          if (btn) btn.disabled = false;

          if (!json.ok || !json.order) {
            errorOrder.textContent = json.error || "Order not found.";
            errorOrder.classList.add("is-active");
            return;
          }

          renderOrderResult(json.order);
        })
        .catch(function () {
          loadingEl.classList.remove("is-active");
          if (btn) btn.disabled = false;
          errorOrder.textContent = "Something went wrong. Please try again.";
          errorOrder.classList.add("is-active");
        });
    });

    if (orderInput) orderInput.addEventListener("input", function () { errorOrder.classList.remove("is-active"); });
    if (emailInput) emailInput.addEventListener("input", function () { errorOrder.classList.remove("is-active"); });
  }

  /* ============================================================
     AWB NUMBER  →  Binderbyte API / JNE fallback
     ============================================================ */
  if (awbForm) {
    awbForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var awb = (awbInput.value || "").trim();

      if (!awb || awb.length < 5) {
        errorAwb.classList.add("is-active");
        awbInput.focus();
        return;
      }
      errorAwb.classList.remove("is-active");
      resultEl.classList.remove("is-active");
      loadingEl.classList.add("is-active");

      var btn = awbForm.querySelector(".ir-to__btn");
      if (btn) btn.disabled = true;

      if (apiKey && apiKey.length > 5) {
        fetch("https://api.binderbyte.com/v1/track?api_key=" + apiKey + "&courier=jne&awb=" + encodeURIComponent(awb))
          .then(function (res) { return res.json(); })
          .then(function (data) {
            loadingEl.classList.remove("is-active");
            if (btn) btn.disabled = false;
            if (data.status === 200 && data.data) {
              renderAwbResult(awb, data.data);
            } else {
              fallbackToJne(awb);
            }
          })
          .catch(function () {
            loadingEl.classList.remove("is-active");
            if (btn) btn.disabled = false;
            fallbackToJne(awb);
          });
      } else {
        setTimeout(function () {
          loadingEl.classList.remove("is-active");
          if (btn) btn.disabled = false;
          fallbackToJne(awb);
        }, 500);
      }
    });

    if (awbInput) awbInput.addEventListener("input", function () { errorAwb.classList.remove("is-active"); });
  }

  function renderOrderResult(data) {
    labelEl.innerHTML = "Order: <strong>" + esc(data.name || "") + "</strong>";

    var status = (data.fulfillmentStatus || "UNFULFILLED").toUpperCase();
    badgeEl.textContent = status;
    badgeEl.className = "ir-to__badge";

    if (status === "FULFILLED") badgeEl.classList.add("ir-to__badge--delivered");
    else if (status === "PARTIAL") badgeEl.classList.add("ir-to__badge--transit");
    else badgeEl.classList.add("ir-to__badge--pending");

    timelineEl.innerHTML = "";

    addTimelineItem("Order placed", data.createdAt ? formatDate(data.createdAt) : "");

    if (data.totalAmount && data.currencyCode) {
      addTimelineItem(
        "Order total",
        formatCurrency(data.totalAmount, data.currencyCode)
      );
    }

    addTimelineItem("Payment", humanize(data.financialStatus || "-"));
    addTimelineItem("Shipping", humanize(data.fulfillmentStatus || "UNFULFILLED"));

    externalEl.style.display = "none";
    resultEl.classList.add("is-active");
    resultEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ============================================================
     RENDER: AWB result (from Binderbyte)
     ============================================================ */
  function renderAwbResult(awb, data) {
    labelEl.innerHTML = "AWB: <strong>" + esc(awb) + "</strong>";

    var summary = data.summary || {};
    var status = (summary.status || "IN TRANSIT").toUpperCase();
    badgeEl.textContent = status;
    badgeEl.className = "ir-to__badge";
    if (status.indexOf("DELIVERED") > -1) badgeEl.classList.add("ir-to__badge--delivered");
    else if (status.indexOf("TRANSIT") > -1 || status.indexOf("PROCESS") > -1) badgeEl.classList.add("ir-to__badge--transit");
    else badgeEl.classList.add("ir-to__badge--pending");

    timelineEl.innerHTML = "";
    var history = data.history || data.manifest || [];
    history.forEach(function (item) {
      var desc = item.desc || item.description || "";
      var date = item.date || "";
      var time = item.time || "";
      addTimelineItem(desc, date + (time ? " \u00b7 " + time : ""));
    });

    externalEl.style.display = "";
    resultEl.classList.add("is-active");
    resultEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ============================================================
     FALLBACK: open JNE + copy AWB
     ============================================================ */
  function fallbackToJne(awb) {
    if (navigator.clipboard) navigator.clipboard.writeText(awb).catch(function () {});
    window.open("https://jne.co.id/tracking-package", "_blank", "noopener,noreferrer");

    labelEl.innerHTML = "AWB: <strong>" + esc(awb) + "</strong>";
    badgeEl.textContent = "CHECK ON JNE";
    badgeEl.className = "ir-to__badge ir-to__badge--pending";
    timelineEl.innerHTML = "";
    addTimelineItem(
      "We\u2019ve opened the JNE tracking page for you.",
      "Your AWB " + esc(awb) + " has been copied to your clipboard \u2014 just paste it on the JNE page."
    );
    externalEl.style.display = "";
    resultEl.classList.add("is-active");
  }

  /* ============================================================
     HELPERS
     ============================================================ */
  function addTimelineItem(desc, meta) {
    var li = document.createElement("li");
    li.className = "ir-to__timeline-item";
    li.innerHTML =
      '<span class="ir-to__timeline-dot"></span>' +
      '<div class="ir-to__timeline-content">' +
        '<p class="ir-to__timeline-desc">' + desc + '</p>' +
        (meta ? '<p class="ir-to__timeline-meta">' + meta + '</p>' : '') +
      '</div>';
    timelineEl.appendChild(li);
  }

  function formatDate(iso) {
    try {
      var d = new Date(iso);
      return d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) +
        " " + d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
    } catch (e) { return iso; }
  }

  function formatCurrency(amount, code) {
    try {
      return Number(amount).toLocaleString("id-ID", { style: "currency", currency: code });
    } catch (e) {
      return Number(amount).toLocaleString("id-ID") + " " + code;
    }
  }

  function humanize(str) {
    return str.replace(/_/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); }).replace(/\b\w+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); });
  }

  function esc(str) {
    var d = document.createElement("div");
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }
});